import React from 'react';
import '../index.scss';
import { GeckoModal, GeckoModalService } from '../../../ui';
import Message from 'routes/conversations/components/Message';
import GeckoLocation from 'services/gecko-location';

const MessageListModal = ({ messages, searchTerm }) => {
  const jumpToConversation = (message) => {
    GeckoLocation.goTo(
      `/conversations/${message.conversation_id}?filter=Contact&contact=${message.sender_id}&message=${message.id}`
    );
    new GeckoModalService().close();
  };

  const renderMessage = (result) => {
    return (
      <div className="AppSearchResult" key={result.id}>
        <Message
          message={result}
          onMessageClick={() => jumpToConversation(result)}
        />
      </div>
    );
  };

  return (
    <GeckoModal
      name={`Messages that contain "${searchTerm}"`}
      children={
        <div className="conversation-message-modal">
          {messages.map(renderMessage)}
        </div>
      }
    />
  );
};

export default MessageListModal;
